<div class="certificate-container">
    <div matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'" class="cert-image"
        [class]="full == true ? 'cert-image-full' : ''">
        <mat-icon svgIcon="certification" class="cert-image"
            [class]="full == true ? 'cert-image-full' : ''">></mat-icon>
    </div>
    <p class="cert-count">
        {{ this.certCount }}
    </p>
</div>